<template>
  <UiCard
    tag="label"
    class="min-w-fit cursor-pointer whitespace-nowrap !rounded-full p-3"
    :active="isActive"
  >
    <input
      :type="type"
      :value="value.id"
      :checked="isActive"
      name="seanceToggler"
      class="peer absolute size-0 shrink-0 opacity-0"
      @change="changeValue"
    />
    <span class="relative block size-full text-sm transition-all">
      <UiDate :value="value.beginsAt" :template="dateTemplate" />,
      <SeanceWeekDay tag="span" :value="value.beginsAt" template=" EEEEEE" />
    </span>
  </UiCard>
</template>

<script lang="ts" setup>
import { isSameYear } from 'date-fns'
import { computed } from 'vue'
import { UiCard, UiDate } from '@/6_shared/ui'
import type { Seance } from '../../model'
import SeanceWeekDay from '../SeanceWeekDay.vue'

type PropType = {
  modelValue?: Seance['id']
  value: Seance
  type?: 'checkbox' | 'radio'
}
type EmitType = {
  (e: 'update:modelValue', value: Seance['id'] | undefined): void
}

const props = withDefaults(defineProps<PropType>(), {
  modelValue: undefined,
  type: 'checkbox'
})
const emit = defineEmits<EmitType>()

const isActive = computed(() => props.modelValue === props.value.id)

const changeValue = () => {
  const emitValue =
    props.type === 'checkbox' ? (isActive.value ? undefined : props.value.id) : props.value.id

  emit('update:modelValue', emitValue)
}
const dateTemplate = computed(() => {
  const isAnotherYear = !isSameYear(new Date(), props.value.beginsAt)

  return `d MMMM${isAnotherYear ? ' yyyy' : ''}`
})
</script>
